import {z} from 'zod'

export const Coordinates = z.object({
    latitude: z.string(),
    longitude: z.string()
})
export type Coordinates = z.infer<typeof Coordinates>

export const Area = z.object({
    id: z.number().int().positive(),
    geo: z.string(),
    country: z.string(),
    external_id: z.string(),
    region: z.string()
})
export type Area = z.infer<typeof Area>
export const AreaResponse = z.object({
    geos: z.array(Area)
})
export type AreaResponse = z.infer<typeof AreaResponse>
